<style scoped lang="less">
.page-container {
  .reset-success{text-align: center;margin: 60px 0;}
  .set-success{margin-top: 20px;font-weight: 600;}
}
/deep/.el-steps--simple {padding: 13px 2%}
.page-container {height: auto;min-width: 900px;position: relative;overflow: hidden;width: 100%;height: 582px;}
.forgot-password {width: 900px;margin: 0px auto;position: absolute;top: 0;left: 0;right: 0;}
.content {background: rgba(255, 255, 255, 0.74);border: 2px solid rgba(204, 204, 204, 0.75);border-radius: 3px;margin-top: 60px;padding: 30px 90px;box-sizing: border-box;}
/deep/.is-success.el-step__title {color: #409eff;}
/deep/.is-process.el-step__title {color: #303133;}
/deep/.is-wait.el-step__title {color: #C0C4CC;}
.forgot-password /deep/.el-step__icon {width: 42px;height: 42px;color: #409eff;font-size: 18px;}
.forgot-password /deep/.is-success .el-step__icon {border: 2px solid #409eff}
.forgot-password /deep/.is-process .el-step__icon {border: 2px solid #303133}
.forgot-password /deep/.is-wait .el-step__icon {border: 2px solid #C0C4CC}
.btn-wr{text-align: center;}
/deep/.el-select {width: 100%;}
.FromCenter {margin-top: 20px;}
</style>

<template>
  <div class="page-container">
    <img class="login-bg-img" src="../../../../static/images/zlkindex/loginbg.jpg" alt="">
    <div class="forgot-password">
      <div class="content">
        <el-steps :active="active" :space="350" finish-status="success" simple>
          <el-step title="确认账号"></el-step>
          <el-step title="重置密码"></el-step>
          <el-step title="重置成功"></el-step>
        </el-steps>
        <VerificationWay v-if="active=='0'" @fun="getChildData"></VerificationWay>
        <Validation v-if="active=='1'" :verificationForm = verificationForm></Validation>
        <div v-if="active=='2'" class="FromCenter">
          <div class="reset-success">
            <p class="set-success">设置成功，去登录</p>
          </div>
          <div class="btn-wr">
            <el-button type="primary" @click="$router.push({path:'/loginindex'})">前往登录页</el-button>
          </div>
        </div>
        <div v-if="active=='3'" class="FromCenter">
          <div class="reset-success">
            <p class="set-success">设置成功，去登录</p>
          </div>
          <div class="btn-wr">
            <el-button type="primary" @click="$router.push({path:'/loginindex'})">前往登录页</el-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/**
 * 安进
 * 忘记密码
 */
import VerificationWay from '../assembly/wjmm/VerificationWay.vue'
import Validation from '../assembly/wjmm/Validation.vue'
export default {
  components: {
    VerificationWay,
    Validation
  },
  data()
  {
    return {
      active: 0,
      verificationForm: {}
    }
  },
  methods: {
    next()
    {
      if (this.active++ > 2) this.active = 0
    },
    activeadd(num)
    {
      if (num)
        this.active = num
      else
        this.active++
    },
    getChildData(data)
    {
      this.verificationForm = data
    }
  }
}
</script>





// WEBPACK FOOTER //
// src/plugins/app/project/Forgotpassword.vue